// extracted by mini-css-extract-plugin
export default {"header":"SafetyAlertHeader_header__229vF","summary":"SafetyAlertHeader_summary__G0NpH","status":"SafetyAlertHeader_status__TCjeX","text":"SafetyAlertHeader_text__lCdZx"};